import {bootstrapApplicationTest} from '@unifocus/react-application';
import messages from './localized-messages';
//import './adapters/mock/MainMockApi';

// if (!window.uftc) {
//     window.uftc = {
//         updateScanPercent: 0,
//         isFpuConnected: () => {
//             console.log("Mock isFpuConnected called");
//             return true;
//         },
//         enroll: (finger) => {
//             console.log(`Mock enroll called with finger: ${finger}`);
//             let progress = 0;
//             window.uftc.updateScanPercent = 0;
//             const interval = setInterval(() => {
//                 progress += 25;
//                 if (progress >= 100) {
//                     progress = 100;
//                     clearInterval(interval);
//                 }
//                 window.uftc.updateScanPercent = progress;
//                 console.log(`Mock updateScanPercent: ${progress}`);
//             }, 1500);
//             return new Uint8Array([1, 2, 3, 4, 5]);
//         },
//         verify: (biometricData) => {
//             console.log(`Mock verify called with data length: ${biometricData.length}`);
//             return "VERIFIED";
//         }
//     };
// }

const rootComponentModule = () => import('./App');
bootstrapApplicationTest({
    applicationId: 'TIMECLOCK',
    messages: messages,
    rootComponentModule: rootComponentModule
});